// extracted by mini-css-extract-plugin
export default {"tasks":"xmkl3","title":"JaYow","inner":"MggNF"};